import { ModalContent, ModalBody, ModalFooter } from "@nextui-org/modal"
import Modal from "@/components/modals/Modal"
import Button from "@/components/Button"

type Props = {
  title: string
  description?: string | React.ReactNode
  confirmText: string
  cancelText?: string
  isDismissable?: boolean
  onConfirm: () => void
}

const ConfirmationModal = ({
  title,
  description,
  confirmText,
  cancelText = "Cancel",
  isDismissable = true,
  onConfirm,
  ...props
}: Props) => {
  return (
    <Modal {...props}>
      <ModalContent>
        {(onClose) => (
          <>
            <ModalBody>
              <div className="type-body-xl font-bold text-white">{title}</div>
              {description && (
                <div className="type-body-sm mt-4 space-y-3 text-ghost">{description}</div>
              )}
            </ModalBody>
            <ModalFooter className="gap-x-0">
              <Button
                theme="blue"
                size="sm"
                onPress={() => {
                  onConfirm()
                  onClose()
                }}
              >
                {confirmText}
              </Button>
              {isDismissable && (
                <Button className="-mr-5" theme="none" size="sm" onPress={onClose}>
                  {cancelText}
                </Button>
              )}
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  )
}

export default ConfirmationModal
